import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

const SliderDotsStyles = css`
  .dot-container {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    margin-top: -8px;
    margin-bottom: 8px;
    .dot-section {
      background-color: #333333;
      width: 54px;
      height: 14px;
      justify-content: center;
      border-radius: 54px;
      opacity: 0.7;
      gap: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      transition: all 0.2s ease-in-out;
      display: inline-block;
      background-color: ${colors.gray.shade33};
      animation: 0.2s ease-in 0s 1 slideInFromLeft;
      @keyframes slideInFromLeft {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(0);
        }
      }
      &.active {
        background-color: #fefefe;
        width: 12px;
        height: 6px;
        border-radius: 6px;
      }
      &.full:last-child {
        width: 4px;
        height: 4px;
      }
      &.full:first-child {
        width: 4px;
        height: 4px;
      }
    }
  }
`;

export { SliderDotsStyles };
